import {
  GET_CLINIC_SUCCESS,
  GET_CLINIC_FAIL,
  GET_CLINIC_DETAILS_SUCCESS,
  GET_CLINIC_DETAILS_FAIL,
  ADD_CLINIC_SUCCESS,
  ADD_CLINIC_FAIL,
  UPDATE_CLINIC_SUCCESS,
  UPDATE_CLINIC_FAIL,
  DELETE_CLINIC_SUCCESS,
  DELETE_CLINIC_FAIL,
  RESET_CLINIC_STATE,
} from "./actionTypes"

const INIT_STATE = {
  clinic: [],
  clinicDetails: [],
  addClinic: [],
  editClinic: [],
  delClinic: [],
}

const Clinic = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CLINIC_SUCCESS:
      return {
        ...state,
        clinic: action.payload,
      }

    case GET_CLINIC_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CLINIC_DETAILS_SUCCESS:
      return {
        ...state,
        clinicDetails: action.payload,
      }

    case GET_CLINIC_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_CLINIC_SUCCESS:
      return {
        ...state,
        clinicDetails: action.payload.data,
        addClinic: action.payload,
      }

    case ADD_CLINIC_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_CLINIC_SUCCESS:
      return {
        ...state,
        clinicDetails: action.payload.data,
        editClinic: action.payload,
      }

    case UPDATE_CLINIC_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CLINIC_SUCCESS:
      return {
        ...state,
        delClinic: action.payload,
      }

    case DELETE_CLINIC_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case RESET_CLINIC_STATE:
      return {
        ...state,
        addClinic: [],
        editClinic: [],
        delClinic: [],
        actClinic: [],
        deactClinic: [],
        clinicDetails: [],
        clinic: [],
        error:[],
      }
    default:
      return state
  }
}

export default Clinic
